import React from 'react';

const FounderSection = () => {
  return (
    <section className="py-5 bg-light position-relative overflow-hidden">
      <div className="container py-4">
        <div className="row align-items-center g-5">
          
          {/* Left Column: Image / Profile Card */}
          <div className="col-lg-5 text-center">
            <div className="position-relative d-inline-block">
              <div 
                className="rounded-4 shadow-lg p-2 bg-white"
                style={{
                  maxWidth: '360px',
                  margin: '0 auto',
                  border: '1px solid rgba(37, 99, 235, 0.15)'
                }}
              >
                <img
                  src="/founder.jpg" 
                  alt="Hasnen Malek - Founder & Lead Engineer at AzyByte Technologies"
                  className="img-fluid rounded-4 w-100"
                  style={{
                    objectFit: 'cover',
                    maxHeight: '400px',
                    display: 'block'
                  }}
                  onError={(e) => {
                    // Fallback avatar icon if founder image path is not yet added
                    e.target.onerror = null;
                    e.target.src = "https://ui-avatars.com/api/?name=Hasnen+Malek&background=2563eb&color=fff&size=512";
                  }}
                />
                <div className="pt-3 pb-2 text-center">
                  <h5 className="fw-bold mb-1 text-dark">Hasnen Malek</h5>
                  <p className="text-primary small fw-semibold mb-2">Founder & Lead Software Architect</p>
                  
                  {/* Founder Social Links */}
                  <div className="d-flex justify-content-center gap-3">
                    <a 
                      href="https://www.linkedin.com/company/azybytetechnologies" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-muted hover-primary fs-5"
                      aria-label="LinkedIn"
                    >
                      <i className="bi bi-linkedin"></i>
                    </a>
                    <a 
                      href="mailto:contact@azybyte.in" 
                      className="text-muted hover-primary fs-5"
                      aria-label="Email"
                    >
                      <i className="bi bi-envelope-fill"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column: Founder's Message */}
          <div className="col-lg-7">
            <div className="ps-lg-3">
              <span className="badge bg-primary-subtle text-primary fw-semibold px-3 py-2 rounded-pill mb-3">
                <i className="bi bi-quote me-1"></i> Leadership Vision
              </span>
              <h2 className="fw-bold text-dark display-6 mb-4">
                Hear From Our Founder
              </h2>
              
              <blockquote className="fs-5 mb-4">
                "At <strong className="text-dark">AzyByte Technologies</strong>, we founded this agency on a single core principle: engineering digital solutions that eliminate complexity and produce concrete business outcomes. 
                <br /><br />
                Whether we are deploying high-concurrency MERN architectures, integrating predictive AI/ML workflows, or scaling secure cloud systems, our focus is never just about writing code—it is about designing resilient infrastructure that helps modern enterprises innovate and scale faster."
              </blockquote>

              <div className="d-flex flex-wrap gap-4 pt-3 border-top border-secondary-subtle">
                <div>
                  <h6 className="fw-bold text-dark mb-0">Hasnen Malek</h6>
                  <small className="text-muted">• AzyByte Technologies</small>
                </div>
                <div className="ms-auto d-flex align-items-center">
                  <a 
                    href="/contact" 
                    className="btn btn-outline-primary btn-sm px-3 py-2 rounded-pill fw-medium"
                  >
                    Connect with Us <i className="bi bi-arrow-right ms-1"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default FounderSection;